export const SHOW_ON_TOP = 'SHOW_ON_TOP'
export const DO_NOT_SHOW = 'DO_NOT_SHOW'
export const SHOW_BELOW = 'SHOW_BELOW'
